import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';

import { useTrackEvent } from '@/lib/analytics';

import { SlackReference } from './slack-reference';
import { LinearReference } from './linear-reference';
import { GoogleDriveReference } from './google-drive-reference';
import { NotionReference } from './notion-reference';
import { ConfluenceReference } from './confluence-reference';
import { SlackReferenceNodeAttributes } from '../../extensions/nodes/slack-reference-node';

import styles from './reference-block.module.scss';

interface ReferenceBlockProps extends NodeViewProps {
  source: 'slack' | 'linear' | 'google_drive' | 'notion' | 'confluence';
}

export const ReferenceBlock = ({ node, source }: ReferenceBlockProps) => {
  const trackEvent = useTrackEvent();

  const attrs = node.attrs as SlackReferenceNodeAttributes; // TODO: Update to more generic type
  const { url } = attrs;

  const trackClick = () => {
    trackEvent('Reference clicked', { source, url });
  };

  const renderReference = () => {
    if (source === 'slack') {
      return <SlackReference onOpen={trackClick} {...attrs} />;
    }
    if (source === 'linear') {
      return <LinearReference onOpen={trackClick} {...attrs} />;
    }
    if (source === 'google_drive') {
      return <GoogleDriveReference onOpen={trackClick} {...attrs} />;
    }
    if (source === 'notion') {
      return <NotionReference onOpen={trackClick} {...attrs} />;
    }
    if (source === 'confluence') {
      return <ConfluenceReference onOpen={trackClick} {...attrs} />;
    }
    return null;
  };

  return (
    <NodeViewWrapper className="reference-node">
      <div className={styles.wrapper}>{renderReference()}</div>
    </NodeViewWrapper>
  );
};
